module.exports = __webpack_public_path__ + "media/images/landing__bg--phone-b7675e4f86c83f2b24e99d21efc572f5.jpg";